import { useState, useEffect } from "react";
import Spinner from "../../Spinner";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import intl from "components/i18n/ReactIntlWrapper";
import { useApi } from "../../../api/ApiProvider";
import Api from "../../../axiosApi/api";
import { useToastMessageQueue } from "components/ToastMessages/ToastMessageProvider";
import { handleAPIError } from "../../../common/errorHandler";
import {
  Box,
  Typography,
} from "@mui/material";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useNavigate } from "react-router";
import { SCOPES } from "common/permissions";
import DefaultActions from "components/DataGrid/DefaultActions";
import { getUserEntity } from "common/UserEntityProvider";
import { usePaginationPreference } from "hooks/usePaginationPreference";

const ProjectCompact = ({ idNumber, input, setInput }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [projectsByClient, setProjectsByClient] = useState([]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const entityType = getUserEntity();

  const api: Api = useApi();
  const toast = useToastMessageQueue();

  const fetchProjectsByClient = async (idNumber: number) => {
    setLoading(true);
    const response = await api.projectApi
      .apiVversionProjectGetByClientIdIdGet(idNumber, "1", {})
      .then((response) => {
        if (response.data) {
          setProjectsByClient(response.data?.data?.queryResult);
          setLoading(false);
        }
      })
      .catch((error) => {
        handleAPIError(error, toast, errors);
        setErrors({ ...errors });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (idNumber) {
      fetchProjectsByClient(idNumber);
    }
  }, [idNumber]);

  const [paginationModel, setPaginationModel] = usePaginationPreference('projectCompact', 10);

  const SORT_STATE = {
    sorting: {
      sortModel: [
        {
          field: 'name',
          sort: 'asc' as const,
        },
      ],
    },
  };

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: intl.get("projectCompact.table.thead.projectName"),
      width: 250,
      flex: 1,
    },
    {
      field: 'client.name',
      headerName: intl.get("projectCompact.table.thead.client"),
      width: 250,
      flex: 1,
      valueGetter: (params, row) => row?.client?.name || '',
    },
    {
      field: 'budget',
      headerName: intl.get("projectCompact.table.thead.budget"),
      width: 150
    },
    {
      field: 'actions',
      headerName: '',
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <DefaultActions
          row={params.row}
          entityType={entityType.entityType}
          onEdit={() => navigate(`/project/detail/${params.id}`)}
          editScopes={[SCOPES['clients.edit']]}
        />
      ),
    },
  ];

  return (<Box>
    <Typography variant="h6" color="primary" display={"flex"} alignItems="center" gap={1}>
      <DescriptionOutlinedIcon className="mb-1" /><span>{intl.get("projectCompact.header")}</span>
    </Typography>
    {loading ? (
      <Box style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spinner small={true} />
      </Box>
    ) : (
      <>
      {projectsByClient && projectsByClient.length > 0 ? (
      <DataGrid
        paginationMode="client"
        sortingMode="client"
        rows={projectsByClient || []}
        columns={columns}
        initialState={SORT_STATE}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[5, 10, 25, 50]}
      />
      ) : (
        <Box style={{ padding: '20px' }}>
        </Box>
      )}
      </>
    )}
  </Box>);
};

export default ProjectCompact;
